export default __webpack_public_path__ + "static/media/DashboardProducts.fb96824f.svg";